module.exports = __webpack_public_path__ + "static/img/3.8af880a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/3.png
// module id = a/as
// module chunks = 0